<template>
  <div class="page-shell">
    <!-- 报告业务接口未就绪前，统一复用该壳子页面承接菜单与信息架构确认。 -->
    <PageHeader :title="title" :description="description">
      <template #actions>
        <slot name="actions">
          <el-button type="primary" plain @click="showBuildingMessage">功能建设中</el-button>
        </slot>
      </template>
    </PageHeader>
    <slot />
    <el-card shadow="never" class="page-card">
      <EmptyState :title="emptyTitle" :description="emptyDescription" icon="el-icon-s-opportunity">
        <el-button type="primary" @click="showBuildingMessage">我知道了</el-button>
      </EmptyState>
    </el-card>
  </div>
</template>

<script>
import EmptyState from '@/components/EmptyState.vue'
import PageHeader from '@/components/PageHeader.vue'

export default {
  name: 'BuildingPage',
  components: {
    EmptyState,
    PageHeader
  },
  props: {
    title: {
      type: String,
      default: '功能建设中'
    },
    description: {
      type: String,
      default: '页面结构已准备完成，等待后续业务接口与交互细节接入。'
    },
    emptyTitle: {
      type: String,
      default: '内容即将开放'
    },
    emptyDescription: {
      type: String,
      default: '当前为第一版 UI 壳子，用于确认信息架构、布局与风格。'
    }
  },
  methods: {
    showBuildingMessage () {
      this.$message.info('该功能正在建设中，后续会结合后端接口逐步完善。')
    }
  }
}
</script>
